/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Information related to a partial building or the whole building
 */
export interface StructureProperty { 
    /**
     * Primary Key
     */
    id: number;
    /**
     * ID of the structure
     */
    structureId: number;
    /**
     * Column name of the datatable with building information. Represents the type of information.
     */
    propertyName: string;
    /**
     * Value that corresponds to the column name
     */
    propertyValue: string;
    /**
     * Translated property value (if applicable)
     */
    translatedValue?: string;
}

